import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ArsenalSwitchDay from '../../Arsenal/ArsenalDaySwitch';
import ArsenalCard from '../../Arsenal/ArsenalCard';

function ArsenalWeekMenu({ dataMenu }) {
    const [currentDate, setCurrentDate] = useState(new Date());

    // Adjust the current date if it's Saturday or Sunday
    const adjustedDate = new Date(currentDate);

    if (adjustedDate.getDay() === 6) { // If the current day is Saturday (6), skip Sunday and move directly to Monday
        adjustedDate.setDate(adjustedDate.getDate() + 2)
    } else if (adjustedDate.getDay() === 0) { // Otherwise, if the current day is Sunday (0), move to Monday
        adjustedDate.setDate(adjustedDate.getDate() + 1)
    }

    // Filter the menu items based on the current date if the week menu
    const menuWeekItems = dataMenu.results.filter(
        (meal) => meal.date === adjustedDate.toISOString().split('T')[0]
    );

    return (
        <>
            <ArsenalSwitchDay
                currentDate={adjustedDate}
                setCurrentDate={setCurrentDate}
            />

            {menuWeekItems.length > 0 ? (
                <>
                    {menuWeekItems.map((meal) => (
                        <ArsenalCard meal={meal} key={meal.id} />
                    ))}
                </>
            ) : (
                <p>Aucun plat disponible pour le moment.</p>
            )}
        </>
    );
}

ArsenalWeekMenu.propTypes = {
    dataMenu: PropTypes.object.isRequired,
};

export default ArsenalWeekMenu;
